import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase } from "@mui/material";
import TableUserList from "../../components/TableUserList";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_ENDPOINT_URL } from "../../util/api";
import { getLocalItem } from "../../util/helper";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useParams } from "react-router-dom";
import { formatDateYMD_HMS } from "../../util/helper";
import _ from "lodash";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns';


const UserAdd = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const token = getLocalItem("key");
  const [validate, setValidate] = useState(false);
  const [data, setData] = useState({
    username: "",
    email: "",
    is_superuser: false,
    is_staff: false,
    is_active: false,
    expiration_date: null
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  const handleAddUser = () => {
    // Validate username and email
    if (!data.username || !data.email) {
      setValidate(true);
      return;
    }

    if (!isValidEmail(data.email)) {
      setValidate(true);
      return;
    }

    axios
      .post(
        `${API_ENDPOINT_URL}/create-user/`,
        {
          username: data.username,
          email: data.email,
          is_superuser: data.is_superuser,
          is_staff: data.is_staff,
          is_active: data.is_active,
          expiration_date: data.expiration_date
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setAlertSeverity("success");
        setAlertMessage("Add user successfully!");
        setTimeout(() => {
          navigate("/user-list");
        }, 500);
      })
      .catch((error) => {
        setAlertSeverity("error");
        setAlertMessage(error.response.data.message);
      })
      .finally(() => {
        setShowAlert(true);
        window.scrollTo({ top: 0 });
        setTimeout(() => {
          setShowAlert(false);
        }, 4000); // Hide alert after 4 seconds
      });
  };

  const handleCheckboxChange = (name) => (event) => {
    setData((prevData) => ({
      ...prevData,
      [name]: event.target.checked,
    }));
  };

  const isValidEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    return emailRegex.test(email);
  };

  return (
    <>
      {showAlert && (
        <Stack sx={{ width: "300px", marginLeft: "auto" }} spacing={2}>
          <Alert variant="filled" severity={alertSeverity}>
            {alertMessage}
          </Alert>
        </Stack>
      )}
      <Box
        mt="50px"
        sx={{
          width: "95%",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            textAlign: "center",
          }}
        >
          <Grid container spacing={0}>
            <Grid item lg={6} sm={12} md={6}>
              <Box>
                <Typography
                  variant="h1"
                  fontSize={40}
                  fontWeight="bold"
                  color="#2699fb"
                  textAlign="left"
                >
                  Create User
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={0}
            ml="16px"
            mt={8}
            item
            xs={12}
            sm={12}
            md={12}
            lg={4}
            textAlign="left"
          >
            <Box>
              <Typography variant="h6" fontSize={15} fontWeight="bold">
                Username
              </Typography>
              <InputBase
                placeholder="Username"
                value={data ? data.username : ""}
                onChange={(e) => setData({ ...data, username: e.target.value })}
                sx={{
                  marginTop: "5px",
                  backgroundColor: "#f1f9ff",
                  width: "100%",
                  border: "2px solid #bce0fd",
                  borderRadius: "10px",
                  color: "#2699fb",
                  padding: "8px 15px 8px 15px",
                }}
              />
            </Box>
            <Box height="16px" width="100%" alignItems="center" color="red">
              {validate && !data.username ? "Username is required !" : ""}
            </Box>
          </Grid>
          <Grid container spacing={2} ml="0px" mt={0}>
            {/* Section 1 - Email input */}
            <Grid item xs={12} sm={12} md={6} lg={6} textAlign="left">
              <Box mt={1}>
                <Typography variant="h6" fontSize={15} fontWeight="bold">
                  E-mail
                </Typography>
                <InputBase
                  placeholder="Email"
                  value={data ? data.email : ""}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "#f1f9ff", // Change background color based on validity
                    width: "100%",
                    border: "2px solid #bce0fd",
                    borderRadius: "10px",
                    color: "#2699fb",
                    padding: "8px 15px 8px 15px",
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {data.email && isValidEmail(data.email) && (
                        <CheckIcon sx={{ color: '#2699fb' }} />
                      )}
                      
                    </InputAdornment>
                  }
                />
              </Box>
              <Box height="16px" width="100%" alignItems="center" color="red">
                {validate && !data.email ? "Email is required!" : ""}
                {validate && data.email && !isValidEmail(data.email)
                  ? "Email not valid!"
                  : ""}
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ mt: "10px", ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>isSuperuser</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <FormControlLabel
                  value={data.is_superuser ? data.is_superuser : false}
                  control={
                    <Checkbox
                      checked={data.is_superuser ? data.is_superuser : false}
                      onChange={handleCheckboxChange('is_superuser')}
                    />
                  }
                  labelPlacement="start"
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>isStaff</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <FormControlLabel
                  value={data.is_staff ? data.is_staff : false}
                  control={
                    <Checkbox
                    checked={data.is_staff ? data.is_staff : false}
                    onChange={handleCheckboxChange("is_staff")}
                    />
                  }
                  labelPlacement="start"
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>isActive</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <FormControlLabel
                  value={data.is_active ? data.is_active : false}
                  control={
                    <Checkbox
                      checked={data.is_active ? data.is_active : false}
                      onChange={handleCheckboxChange('is_active')}
                    />
                  }
                  labelPlacement="start"
                />
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ mt: "0px", ml: "0px" }}>
            <Grid item xs={2} display="inline-flex">
              <Box mt={1} display="flex" justifyContent="flex-start">
                <Typography style={{ fontWeight: "bold" }}>Expired Date</Typography>
              </Box>
            </Grid>
            <Grid item xs={10} display="inline-flex">
              <Box mt={1} ml={3} display="flex" justifyContent="flex-start">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker slotProps={{ textField: { variant: "standard" } }} 
                  value={data.expiration_date}
                  onChange={(e) => {
                    const dateObject = e.toDate();
                    const formattedDate = format(dateObject, 'yyyy-MM-dd');
                    setData({ ...data, expiration_date: formattedDate });
                  }}
                  format="YYYY/MM/DD"
                />
              </LocalizationProvider>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item textAlign="left">
              <Box mt={1}>
                <Box
                  mt={5}
                  padding="11px"
                  onClick={handleAddUser}
                  sx={{
                    backgroundColor: "#2699fb",
                    color: "white",
                    borderRadius: "4px",
                    "&:hover": {
                      cursor: "pointer",
                    },
                    width: "200px",
                  }}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    textAlign="center"
                    m={0}
                    cursor="pointer"
                  >
                    Create
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default UserAdd;
